// src/helpers/validationHelpers.js

export const validUSAStates = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT',
  'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI',
  'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH',
  'NJ', 'NM', 'NY', 'NC', 'ND', 'OH',
  'OK', 'OR', 'PA', 'RI', 'SC', 'SD',
  'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV',
  'WI', 'WY'
];

export async function validateZipCode(zipcode) {
  try {
      const response = await fetch(`https://api.zippopotam.us/us/${zipcode}`);
      return response.status === 200;
  } catch (error) {
      return false;
  }
}

export function validateState(state) {
  return validUSAStates.includes(state);
}

export function validateNotEmpty(value) {
  return value.trim().length > 0;
}